export default {
  INCLUDE: "include",
  SAME_ORIGIN: "same-origin",
  OMIT: "omit",
};
